import React from 'react'
import styles from './NoCaddieFound.module.scss'

/**
 * Props:
 *  - onCreate: () => void (사용하지 않음, 공고 작성 기능 미구현)
 */
export const NoCaddieFound = ({ onCreate }) => (
	<div className={styles.container}>
		<p className={styles.title}>현재 조건에 맞는 인재(캐디)가 없어요.</p>
		{/* <p className={styles.subtitle}>직접 공고를 작성하여 인재를 구해보는 건 어떠세요?</p>
		<button type="button" className={styles.button} onClick={onCreate}>
			<PencilIcon className={styles.icon} />
			<span className={styles.buttonText}>여러 캐디 지원자를 받아보고 싶어요</span>
		</button> */}
	</div>
)
